import React from 'react';
import { createBrowserRouter } from 'react-router-dom';

import App from './App';
import BlogList from './routes/BlogList';
import Blog from './routes/Blog';

const router = createBrowserRouter([
    {
        path: '/',
        children: [
            {
                index: true,
                element: <App />
            },
            {
                path: 'blog',
                children: [
                    {
                        index: true,
                        element: <BlogList />
                    },
                    {
                        path: ':id',
                        element: <Blog />
                    }
                ]
            }
        ]
    }
]);

export default router;